const AppointmentStatus = Object.freeze({
  PENDING: 'pending',
  COLLECTED: 'collected',
  COMPLETE: 'complete',
  DEACTIVATED: 'deactivated',
  CONFIRMED: 'confirmed',
  CANCELED: 'canceled'
})

export default AppointmentStatus